module.exports = __webpack_public_path__ + "img/boas-vindas-cardapio.98f6ba8c.jpg";